import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const extractProductDescription = (payload, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'EXTRACTING_PRODUCT_DESCRIPTION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/us/extract/product-dtls`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'EXTRACTING_PRODUCT_DESCRIPTION_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'EXTRACTING_PRODUCT_DESCRIPTION_FAILED',
              payload: `Failed to generate product description`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'EXTRACTING_PRODUCT_DESCRIPTION_FAILED',
            payload: `Failed to generate product description`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'EXTRACTING_PRODUCT_DESCRIPTION_FAILED',
        payload: `Failed to generate product description`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default extractProductDescription;
